'use strict';

/* global Modernizr */

function ProcessingJobDetailController (
        $state, $stateParams, $rootScope, $scope, $window,
        job, SaturnGrowl, ManagerActions, ManagerStore,
        DataExportService, PdfPreviewActions, Flux, AnalyticsService, MetricsService, ContourPreviewActions) {

  const vm = this;
  vm.job = job;
  vm.renderedFileExports = [];

  vm.modernizrAvailable = typeof Modernizr !== 'undefined';
  const deviceAgent = navigator.userAgent.toLowerCase();
  // TODO: refactor this to be cleaner and remove redundancy. we don't need to support Bada either.
  vm.modernizrTouch = Modernizr.touch && (deviceAgent.match(/(iphone|ipod|ipad)/) || deviceAgent.match(/(android)/) || deviceAgent.match(/(iemobile)/) || deviceAgent.match(/iphone/i) || deviceAgent.match(/ipad/i) || deviceAgent.match(/ipod/i) || deviceAgent.match(/blackberry/i) || deviceAgent.match(/bada/i));

  const PdfStore = Flux.Store.get('PdfPreviewStore');
  const SiteStore = Flux.Store.get('SiteStore');

  DataExportService.getFiles(vm.job.dataFiles, 'projection');
  vm.boxFolderLink = DataExportService.getBoxLink();
  vm.projections = DataExportService.projections;
  vm.showContourButton = DataExportService.shouldShowContourButton();
  vm.openBoxFolder = DataExportService.openBoxFolder;
  vm.downloadFile = DataExportService.downloadFile;
  vm.TOOLTIPS = DataExportService.TOOLTIPS;
  vm.showResolutions = DataExportService.showResolutions;
  vm.hasFiles = DataExportService.hasFiles;
  vm.isDatacaptureProcessing = vm.job.state !== 'Completed';
  vm.hasOrthomosaic = DataExportService.hasOrthomosaic;
  vm.ORDER = DataExportService.ORDER;
  vm.showFiles = DataExportService.showFiles;
  vm.geoid = DataExportService.getGeoid();

  vm.showContourPreview = () => {

    if (vm.TOOLTIPS.dxf.isProcessing) {
      return;
    }

    ContourPreviewActions.ShowContourPreview.dispatch();
  };

  vm.showPdfPreview = () => {

    if (vm.TOOLTIPS.pdf.isProcessing) {
      return;
    }

    PdfPreviewActions.ShowPdfPreview.dispatch();
  };


  vm.pdfProcessingStarted = () => {

    DataExportService.toggleExportProcessing('PDF');

    MetricsService.track('pdfReady', 'pdfRequest', {
      forceNewFlow: true
    });

    SaturnGrowl.newGrowl('Your PDF is processing. We\'ll let you know as soon as it\'s ready!', {
      id:'pdf-processing',
      time: -1
    });
  };

  vm.pdfProcessingFinished = () => {

    DataExportService.toggleExportProcessing('PDF');

    this.s3Url = PdfStore.get('uri');

    MetricsService.track('pdfReady', 'pdfReady');

    SaturnGrowl.removeGrowl({
      id: 'pdf-processing'
    });

    SaturnGrowl.newGrowl('Your PDF is ready to download.', {
      id: 'pdf-ready',
      time: -1,
      cta: {
        label: 'Download PDF',
        callback: this.downloadPdf.bind(this)
      }
    });
  };

  vm._handleSiteUpdated = (site) => {

    if (vm.job.site.id === site.id) {
      vm.job.site = site;
    }
  };

  vm.downloadPdf = function() {
    $window.location.href = this.s3Url;

    SaturnGrowl.removeGrowl({
      id: 'pdf-ready'
    });

    let dataExportId = PdfStore.get('dataExportId');
    let site = vm.job.site.id;
    AnalyticsService.track('[CORE] PDF', 'PDF Downloaded', {
      dataExportId: dataExportId,
      siteId: site.id,
      siteName: site.name
    });
  };

  ManagerActions.OpenDetailView.dispatch();

  /**======== Button Actions ========**/
  vm.closeUserView = () => {

    $state.go('manager.processingJobs');
    ManagerActions.CloseDetailView.dispatch();
  };

  vm.deleteDataSet = () => {

    if (vm.job.state === 'Completed') {

      $rootScope.$broadcast('dialog:datasets:promptDelete', {
        job: vm.job
      });
    }
  };

  $scope.$on('dialog:datasets:confirmDelete', (ev, data) => {

    ManagerActions.DeleteDataSet.dispatch(data.id);
    ManagerStore.once(ManagerStore.Events.ProcessingJobDestroyed, () => {

      $state.go('manager.processingJobs');
      SaturnGrowl.newGrowl('The dataset was successfully deleted', {
        id: 'dataset-deleted',
        time: 5000
      });
    });
  });

  PdfStore.on(PdfStore.Events.Processing, vm.pdfProcessingStarted.bind(vm), $scope);
  PdfStore.on(PdfStore.Events.Finished, vm.pdfProcessingFinished.bind(vm), $scope);
  SiteStore.on(SiteStore.Events.ChangedWithUpdatedSite, vm._handleSiteUpdated.bind(vm));
}

ProcessingJobDetailController.$inject = [
  '$state', '$stateParams', '$rootScope', '$scope', '$window',
  'job', 'SaturnGrowl', 'ManagerActions', 'ManagerStore',
  'DataExportService', 'PdfPreviewActions', 'sbFlux', 'AnalyticsService', 'MetricsService', 'ContourPreviewActions'
];

module.exports = ProcessingJobDetailController;



// WEBPACK FOOTER //
// ./src/app/manager/processing/ProcessingJobDetailController.js